export enum enumCreStatus {
  Active= 1,
  Cancelled,
  Inactive
}
export namespace enumCreStatus {
  export function values() {
    return Object.keys(enumCreStatus).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}
